const predefinedColors = [
  "white",
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "indigo",
  "purple",
  "pink",
  "gray",
  "brown",
  "teal",
];

const ColorInput = ({ label, value, onChange }) => {
  return (
    <div className="mb-6 w-full">
      <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
        {label}
      </label>

      {/* Color Picker and Hex Input */}
      <div className="flex flex-col md:flex-row items-start md:items-center gap-3 w-full">
        <input
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="h-10 w-14 border-none outline-none cursor-pointer"
          aria-label="Color Picker"
        />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#000000 or 'blue'"
          className="px-3 py-2 w-28 border rounded-md dark:bg-gray-600 dark:text-gray-200"
          aria-label="Hex or Color Name"
        />
      {/* Predefined Color Buttons */}
      <div className="flex flex-wrap gap-2 mt-4">
        {predefinedColors.map((color, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => onChange(color)}
            className={`w-6 h-6 rounded-full transition-all duration-150 border-2 ${
              value === color
                ? "ring-2 ring-offset-2 ring-blue-500 scale-110"
                : "hover:scale-105 border-gray-300"
            }`}
            style={{ backgroundColor: color }}
            aria-label={`Select ${color}`}
            title={color}
          />
        ))}
      </div>
      </div>

    </div>
  );
};

export default ColorInput;
